import {TargetBlank} from '@wandb/weave/common/util/links';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Segment} from 'semantic-ui-react';

import DOC_URLS from '../util/doc_urls';
import CollapsibleJSONTable from './CollapsibleJSONTable';

interface RunConfigTableProps {
  config: any; // Receives raw config (json object)
}

const RunConfigTable: React.FC<RunConfigTableProps> = React.memo(({config}) => {
  if (
    config == null ||
    typeof config !== 'object' ||
    Object.keys(config).length === 0 ||
    (Object.keys(config).length === 1 && config._wandb != null)
  ) {
    return (
      <Segment>
        <p>No config parameters saved for this run.</p>
        <p>
          Check the{' '}
          <TargetBlank href={DOC_URLS.config}>
            configuration documentation
          </TargetBlank>{' '}
          for more information.
        </p>
      </Segment>
    );
  }
  return (
    <div className="run-config-table">
      <CollapsibleJSONTable data={config} />
    </div>
  );
});

export default RunConfigTable;
